import React from 'react';
import { ChipIcon, ChipStyled, ChipText } from './Chip.styles';
/**
 * @param label: text to display on chip
 * @param variant: color variant of chip background
 * @param color: color of chip background
 * @param icon: icon on left side of text
 * @returns a tag-like chip component
 */
const Chip = ({ label, variant, color, icon, ...props }) => {
    return (React.createElement(ChipStyled, { color: color, variant: variant, ...props },
        icon && React.createElement(ChipIcon, { name: icon, size: 's' }),
        React.createElement(ChipText, null, label)));
};
export default Chip;
//# sourceMappingURL=Chip.js.map